module.exports = __webpack_public_path__ + "static/img/henri-schein.1915ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/henri-schein.jpg
// module id = B1LV
// module chunks = 2